import { render, staticRenderFns } from "./embed_settings.vue?vue&type=template&id=50009108&scoped=true&"
import script from "./embed_settings.vue?vue&type=script&lang=js&"
export * from "./embed_settings.vue?vue&type=script&lang=js&"
import style0 from "./embed_settings.vue?vue&type=style&index=0&id=50009108&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50009108",
  null
  
)

export default component.exports